export class error_message {
  public displayMode: string;
  public uiLocales: string;
  public error: string;
  public errorDescription: string;
  public requestId: string;
  public redirectUri: string;
  public responseMode: string;
}
